import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/blog/ivd-clinical-trials-integration")({
  head: () => buildRouteHead("/es/blog/ivd-clinical-trials-integration", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/blog/ivd-clinical-trials-integration", replace: true });
  },
});
